export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";